import React from 'react';
import { Box, Typography } from '@mui/material';

const CandidateViewKnowledgeGraph = ({ candidateEmail, preloadedCandidate, height }) => {
  return (
    <Box
      sx={{
        height: height || '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.1)',
        borderRadius: 1,
        p: 3,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: 'white', mb: 2 }}>
          Knowledge Graph
        </Typography>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
          Knowledge graph visualization coming soon...
        </Typography>
        {candidateEmail && (
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', mt: 1, display: 'block' }}>
            Email: {candidateEmail}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CandidateViewKnowledgeGraph;
